/* eslint-disable @typescript-eslint/no-explicit-any */
export const getCacheKey = ({
  supplierID,
  userID,
  endpoint,
  ...params
}: {
  userID: number;
  supplierID: string;
  endpoint: string;

  [key: string]: any;
}): string => {
  return `${userID}-${supplierID}-${JSON.stringify({ endpoint, ...params })}`;
};
